import Axios from './baseApi'

export default {
  async fetch(searchModel) {
    return await Axios.post('/api-master-data/v1/search', searchModel);
  }
}
